import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { ROLES } from 'src/app/models/role';
import { IdentityService } from 'src/app/services/common/identity.service';

@Injectable({
  providedIn: 'root',
})
export class SupplierFactoryGuard implements CanActivate {
  constructor(
    private identityService: IdentityService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.identityService.getCurrentMeUser().pipe(
      map((user) => {
        if (user && user.role === ROLES.SUPPIER_FACTORY) {
          this.router.navigate(['/lookup']);
          return false;
        }
        return true;
      })
    );
  }
}
